import React, { useEffect, useState } from "react";
import { Mail, Phone } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { api } from "@/lib/api";

export function SupportContacts() {
  const { t } = useLanguage();
  const [staff, setStaff] = useState(null);
  useEffect(() => { api.get("/staff").then(({ data }) => setStaff(data)).catch(() => setStaff([])); }, []);

  if (staff === null) return <p className="px-5 py-8 text-center text-sm text-muted-foreground">{t("support.loading")}</p>;
  if (staff.length === 0) return <p className="px-5 py-12 text-center text-sm text-muted-foreground">{t("support.empty")}</p>;

  return (
    <div className="px-5 py-5">
      <p className="text-sm text-muted-foreground">{t("support.subtitle")}</p>
      <ul className="mt-5 grid gap-4 sm:grid-cols-2">
        {staff.map((s) => (
          <li key={s.id} className="rounded-xl border border-border bg-card p-4">
            <p className="font-medium text-foreground">{s.name}</p>
            <p className="text-xs text-muted-foreground">{s.role}</p>
            <div className="mt-3 flex flex-col gap-1.5 text-sm">
              <a href={`mailto:${s.email}`} className="inline-flex items-center gap-2 text-accent hover:underline"><Mail className="h-4 w-4" />{s.email}</a>
              {s.phone && <span className="inline-flex items-center gap-2 text-muted-foreground"><Phone className="h-4 w-4" />{s.phone}</span>}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
